/**
 * Error types for internal-api responses. Ported bit-exact from
 * src/app/adyen/errors.ts — the 409/410 typed errors are part of the
 * cross-frame dispatch contract surface (see specs/app/index.md::Decisions
 * 2026-05-13: claim conflict / closed both currently surface as
 * card-payment-form-invalid via branch 10d).
 */

export class HttpError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message)
    this.name = 'HttpError'
  }
}

export class SessionConflictError extends HttpError {
  constructor(message: string) {
    super(message, 409)
    this.name = 'SessionConflictError'
  }
}

export class SessionClosedError extends HttpError {
  constructor(message: string) {
    super(message, 410)
    this.name = 'SessionClosedError'
  }
}
